import { render, staticRenderFns } from "./MonitorPage.vue?vue&type=template&id=1321494a&scoped=true"
import script from "./MonitorPage.vue?vue&type=script&lang=ts"
export * from "./MonitorPage.vue?vue&type=script&lang=ts"
import style0 from "./MonitorPage.vue?vue&type=style&index=0&id=1321494a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321494a",
  null
  
)

export default component.exports